import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FirstStepIcon = (props) => (
  <SvgIcon
    width="36.341"
    height="29.399"
    viewBox="0 0 36.341 29.399"
    {...props}
  >
    <g id="Palier1" transform="translate(-5 -13.595)">
      <g id="Groupe_6161" transform="translate(5 13.595)">
        <path
          id="Tracé_3736"
          d="M34.793 13.6l-3.055 4.989L28.68 13.6h-9.308l6.654 10.863a10.151 10.151 0 1 0 11.425 0L44.106 13.6h-9.313zm-11.751 2.051h4.485l3 4.9-1.543 2.519a10.1 10.1 0 0 0-1.153.4zm16.792 17.192a8.1 8.1 0 1 1-8.1-8.1 8.1 8.1 0 0 1 8.1 8.1zm-4.19-9.369a10.094 10.094 0 0 0-3.9-.782h-.109l4.314-7.044h4.491z"
          transform="translate(-13.569 -13.595)"
        />
        <path
          id="Tracé_3737"
          d="M32.772 50.993a1.028 1.028 0 0 0 2.056 0 4.925 4.925 0 0 1 4.9-4.9 1.028 1.028 0 1 0 0-2.056 6.965 6.965 0 0 0-6.956 6.956z"
          transform="translate(-21.558 -31.744)"
        />
        <path
          id="Tracé_3738"
          d="M83.68 49.57l-4.656 1.664a1.036 1.036 0 1 0 .7 1.951l4.656-1.664a1.036 1.036 0 0 0-.7-1.951z"
          transform="translate(-48.724 -35.008)"
        />
        <path
          id="Tracé_3739"
          d="M83.574 70.187L79.1 68.07a1.036 1.036 0 1 0-.887 1.872l4.469 2.116a1.036 1.036 0 0 0 .887-1.872z"
          transform="translate(-48.3 -46.015)"
        />
        <path
          id="Tracé_3740"
          d="M6.036 72.828a1.031 1.031 0 0 0 .348-.061l4.657-1.667a1.036 1.036 0 1 0-.7-1.951l-4.654 1.667a1.036 1.036 0 0 0 .349 2.011z"
          transform="translate(-5 -46.683)"
        />
        <path
          id="Tracé_3741"
          d="M12.124 51.726L7.655 49.61a1.036 1.036 0 1 0-.887 1.872l4.469 2.118a1.036 1.036 0 1 0 .886-1.872z"
          transform="translate(-5.701 -35.008)"
        />
      </g>
    </g>
  </SvgIcon>
);

export default FirstStepIcon;
